import React, { createContext, FC, useContext, useState } from "react";
import moment from "moment-timezone";

const defaultTimezone = localStorage.getItem("moment-tz-timezone");

if(defaultTimezone){
    moment.tz.setDefault(defaultTimezone);
}


console.log("s=>",moment().format("Z"));

type TimezoneType = {
    timezone: string | null,
    setTimezone: (timezone: string) => void
}

const TimezoneContext = createContext<TimezoneType>({
    timezone: null,
    setTimezone: () => { }
});

export const useTimezone = () => {

    const contenxt = useContext(TimezoneContext);


    return contenxt;

}



const TimezoneProiver: FC = ({ children }) => {

    const [timezone, setTimezone] = useState<string | null>(defaultTimezone ? defaultTimezone : moment.tz.guess());

    const updateTimezone = (t: string) => {

        // console.log("t=>",t);

        localStorage.setItem("moment-tz-timezone", t);

        moment.tz.setDefault(t);

        setTimezone(t);

    }



    return (
        <TimezoneContext.Provider key={timezone} value={{ timezone: timezone, setTimezone: updateTimezone }}>
            {children}
        </TimezoneContext.Provider>
    )

}


export default TimezoneProiver;